module.exports = __webpack_public_path__ + "img/lunatic-festival.a23e502f.png";